import styled from 'styled-components';

const Styled = styled.div`
    display: flex;
    min-width: 0;

    .number {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        direction: rtl;

        .bidi-punctuation {
            /* to solve the problem of punctuation in rtl https://davidwalsh.name/rtl-punctuation */
            unicode-bidi: plaintext; 
        }
    }

    .label {
        padding-left: 4px;
        white-space: nowrap;
    }
`;
export default Styled;
